/**
 * @desc updateToDetails
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: Array<defs.tms.TransportToDetailBean>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/updateToDetails`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
